import {
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { ReactElement } from "react"

const ContractCreate = (): ReactElement => {
  return (
    <Create redirect="list">
      <SimpleForm>
        <ReferenceInput source="user_id" reference="users">
          <SelectInput isRequired />
        </ReferenceInput>
        <ReferenceInput source="user_role" reference="roles">
          <SelectInput label="Rôle" optionText="label" isRequired />
        </ReferenceInput>

        <TextInput source="username" isRequired />
      </SimpleForm>
    </Create>
  )
}

export default ContractCreate
